import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';

export default async function setToken({ client, config }: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/guest/set/token', config.api.url);
  const result = await client.get(url.href, {params});
  return result?.data;
}
